/* eslint-disable no-unused-vars */
import { useEffect, useRef } from 'react'
import { Colors } from '../../../styles'

import {
  Box,
  Tooltips,
  TittleTooltips,
  TooltipsWrapper,
  ContentTooltips,
  TOJItem,
  TOJName,
  TOJValue,
  TOJMaxValue,
  TOJContainer,
  TOJDescription,
  TOJValueWrapper,
  TOJCirclePercentage,
  TOJItemFilled,
  TOJInfoWrapper,
  TOJCircleWrapper,
  TOJItemFillWrapper,
  TOJNewItem,
  TOJNewPercentageBox,
  TOJNewPercentageText,
  TOJNewProductType,
  TOJNewVolumeWrapper,
  TOJNewVolumeText,
  TOJNewProgressTrack,
  TOJNewProgressFill,
  TOJNewItemLg,
  TOJNewPercentageBoxLg,
  TOJNewPercentageTextLg,
  TOJNewProductTypeLg,
  TOJNewVolumeTextLg,
  TOJNewProgressTrackLg,
  TOJNewProgressFillLg,
  TOJCardItem,
  TOJCardRing,
  TOJCardPercentageText,
  TOJCardProductType,
  TOJCardVolumeText,
  TOJCardProgressTrack,
  TOJCardProgressFill,
  TOJPillItem,
  TOJPillRing,
  TOJPillPercentageText,
  TOJPillProductType,
  TOJPillVolumeText,
  TOJPillDivider,
  TOJPillProgressTrack,
  TOJPillProgressFill,
  TOJBarItem,
  TOJBarContent,
  TOJBarRing,
  TOJBarPercentageText,
  TOJBarProductType,
  TOJBarVolumeText,
  TOJBarTrack,
  TOJBarFill,
} from './dashboard-jetty.styled'
import { Tooltip } from '@material-ui/core'
import { durationToDayHourMinute } from '../../../utils/date'

export const RenderTOJ = ({
  data,
  handleClick,
  vesselSize,
  isDolphin = false
}) => {
  const elementRef = useRef()
  const height = _getTOJPositions(vesselSize).height

  const updateScale = () => {
    const rightPosition = _getTOJRightPositions(vesselSize)

    if (elementRef.current) {
      elementRef.current.style.right = isDolphin ? '3.7rem' : rightPosition
      if (isDolphin) {
        elementRef.current.style.bottom = '1rem'
      }
    }
  }

  useEffect(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  return (
    <TOJContainer
      width='10rem'
      height={height}
      ref={elementRef}
      isDolphin={isDolphin}
    >
      {data?.Child?.map((item, index) => {
        const percentage = item.Total_Progress_Activity > 100 ? 100 : item.Total_Progress_Activity
        return (
          <TOJItem onClick={() => handleClick(item)} key={index}>
            <TOJCircleWrapper percentage={percentage}>
              <TOJCirclePercentage>{percentage}%</TOJCirclePercentage>
            </TOJCircleWrapper>
            <TOJInfoWrapper>
              <Tooltip title={item.Product_Type} placement='top'>
                <TOJDescription>
                  <TOJName>{item.Product_Type}</TOJName>
                  <TOJValueWrapper>
                    <TOJValue>{item.Volume}/</TOJValue>
                    <TOJMaxValue>{item.Quantity}</TOJMaxValue>
                  </TOJValueWrapper>
                </TOJDescription>
              </Tooltip>
              <TOJItemFillWrapper>
                <TOJItemFilled percentage={percentage} />
              </TOJItemFillWrapper>
            </TOJInfoWrapper>
          </TOJItem>
        )
      })}
    </TOJContainer>
  )
}

export const RenderTOJNew = ({
  data,
  handleClick,
  vesselSize,
  isDolphin = false
}) => {
  const elementRef = useRef()
  const height = _getTOJPositions(vesselSize).height

  const updateScale = () => {
    const rightPosition = _getTOJRightPositions(vesselSize)

    if (elementRef.current) {
      elementRef.current.style.right = isDolphin ? '3.7rem' : rightPosition
      if (isDolphin) {
        elementRef.current.style.bottom = '1rem'
      }
    }
  }

  useEffect(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  return (
    <TOJContainer
      width='10rem'
      height={height}
      ref={elementRef}
      isDolphin={isDolphin}
    >
      {data?.Child?.map((item, index) => {
        const percentage = item.Total_Progress_Activity > 100 ? 100 : item.Total_Progress_Activity
        return (
          <TOJPillItem onClick={() => handleClick(item)} key={index}>
            <TOJPillRing percentage={percentage}>
              <TOJPillPercentageText>{percentage}%</TOJPillPercentageText>
            </TOJPillRing>
            <TOJPillDivider />
            <Tooltip title={item.Product_Type} placement='top'>
              <TOJPillProductType>{item.Product_Type}</TOJPillProductType>
            </Tooltip>
            <TOJPillVolumeText>{item.Volume} / {item.Quantity}</TOJPillVolumeText>
            <TOJPillProgressTrack>
              <TOJPillProgressFill percentage={percentage} />
            </TOJPillProgressTrack>
          </TOJPillItem>
        )
      })}
    </TOJContainer>
  )
}

export const RenderTOJNewV2 = ({
  data,
  handleClick,
  vesselSize,
  isDolphin = false
}) => {
  const elementRef = useRef()
  const height = _getTOJPositions(vesselSize).height

  const updateScale = () => {
    const rightPosition = _getTOJRightPositions(vesselSize)

    if (elementRef.current) {
      elementRef.current.style.right = isDolphin ? '3.7rem' : rightPosition
      if (isDolphin) {
        elementRef.current.style.bottom = '1rem'
      }
    }
  }

  useEffect(() => {
    updateScale()
    window.addEventListener('resize', updateScale)
    return () => window.removeEventListener('resize', updateScale)
  }, [])

  const item = data?.Child?.[0]
  if (!item) return null
  const percentage = item.Total_Progress_Activity > 100 ? 100 : item.Total_Progress_Activity

  return (
    <TOJContainer
      width='10rem'
      height={height}
      ref={elementRef}
      isDolphin={isDolphin}
    >
      <TOJBarItem onClick={() => handleClick(item)}>
        <TOJBarTrack>
          <TOJBarFill percentage={percentage} />
        </TOJBarTrack>
        <TOJBarContent>
          <TOJBarRing percentage={percentage}>
            <TOJBarPercentageText>{percentage}%</TOJBarPercentageText>
          </TOJBarRing>
          <Tooltip title={item.Product_Type} placement='top'>
            <TOJBarProductType>{item.Product_Type}</TOJBarProductType>
          </Tooltip>
          <TOJBarVolumeText>{item.Volume} / {item.Quantity}</TOJBarVolumeText>
        </TOJBarContent>
      </TOJBarItem>
    </TOJContainer>
  )
}

export const _renderTooltips = (data, id, degree) => {
  return (
    <TooltipsWrapper deg={degree}>
      <Tooltips
        id={id}
        backgroundColor={Colors.pureWhite}
        textColor={Colors.black}
      >
        <Box>
          <TittleTooltips>Vessel Name</TittleTooltips>
          <br />
          <ContentTooltips>{data.Vessel_Name}</ContentTooltips>
        </Box>
        <Box>
          <TittleTooltips>Client</TittleTooltips>
          <br />
          <ContentTooltips>{data.Client_Name}</ContentTooltips>
        </Box>
        <Box>
          <TittleTooltips>Agent</TittleTooltips>
          <br />
          <ContentTooltips>{data.Agent_Name}</ContentTooltips>
        </Box>
        <Box>
          <TittleTooltips>Service Request No</TittleTooltips>
          <br />
          <ContentTooltips>{data.SrNo}</ContentTooltips>
        </Box>
        <Box>
          <TittleTooltips>Length Overall</TittleTooltips>
          <br />
          <ContentTooltips>{`${data.Loa} Meters`}</ContentTooltips>
        </Box>
        <Box>
          <TittleTooltips>Berthing Duration</TittleTooltips>
          <br />
          <ContentTooltips>
            {durationToDayHourMinute(data.Actual_Berth_Dur)}
          </ContentTooltips>
        </Box>
      </Tooltips>
    </TooltipsWrapper>
  )
}

export const _vesselPositions = {
  LCT: [
    // Berth 1 (index 0)
    {
      Small: { top: '29.6%', left: '67.5%' },
      Medium: { top: '26%', left: '67.1%' },
      Large: { top: '19.4%', left: '66.7%' }
    },
    // Berth 2
    {
      Small: { top: '29.6%', left: '59.5%' },
      Medium: { top: '26%', left: '59.1%' },
      Large: { top: '19.4%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '29.6%', left: '49.3%' },
      Medium: { top: '26%', left: '48.9%' },
      Large: { top: '19.4%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '29.6%', left: '39.1%' },
      Medium: { top: '26%', left: '38.7%' },
      Large: { top: '19.4%', left: '38.3%' }
    },
    // Berth 5
    {
      Small: { top: '29.6%', left: '31%' },
      Medium: { top: '26%', left: '30.7%' },
      Large: { top: '19.4%', left: '30.3%' }
    },
    {
      Small: { top: '39.4%', left: '39.3%' },
      Medium: { top: '39.4%', left: '39.3%' },
      Large: { top: '39.4%', left: '39.3%' }
    }
  ],
  TSV: [
    // Berth 1 (index 0)
    {
      Small: { top: '32.9%', left: '67.4%' },
      Medium: { top: '28.5%', left: '67.1%' },
      Large: { top: '24%', left: '66.7%' }
    },
    // Berth 2
    {
      Small: { top: '32.9%', left: '59.4%' },
      Medium: { top: '28.5%', left: '59.1%' },
      Large: { top: '24%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '32.9%', left: '49.3%' },
      Medium: { top: '28.5%', left: '48.9%' },
      Large: { top: '24%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '32.9%', left: '39.1%' },
      Medium: { top: '28.5%', left: '38.7%' },
      Large: { top: '24%', left: '38.3%' }
    },
    // Berth 5
    {
      Small: { top: '32.9%', left: '31%' },
      Medium: { top: '28.5%', left: '30.7%' },
      Large: { top: '24%', left: '30.3%' }
    },
    {
      Small: { top: '39.5%', left: '39.3%' },
      Medium: { top: '39.5%', left: '39.3%' },
      Large: { top: '39.5%', left: '39.3%' }
    }
  ],
  Rig: [
    // Berth 1 (index 0)
    {
      Small: { top: '31.2%', left: '64.8%' },
      Medium: { top: '31.2%', left: '64.8%' },
      Large: { top: '31.2%', left: '64.8%' }
    },
    // Berth 2
    {
      Small: { top: '31.2%', left: '56.9%%' },
      Medium: { top: '31.2%', left: '56.9%' },
      Large: { top: '31.2%', left: '56.9%' }
    },
    // Berth 3
    {
      Small: { top: '31.2%', left: '46.6%' },
      Medium: { top: '31.2%', left: '46.6%' },
      Large: { top: '31.2%', left: '46.6%' }
    },
    // Berth 4
    {
      Small: { top: '31.2%', left: '36.5%' },
      Medium: { top: '31.2%', left: '36.5%' },
      Large: { top: '31.2%', left: '36.5%' }
    },
    // Berth 5
    {
      Small: { top: '31.2%', left: '28.5%' },
      Medium: { top: '31.2%', left: '28.5%' },
      Large: { top: '31.2%', left: '28.5%' }
    },
    {
      Small: { top: '36.5%', left: '40.9%' },
      Medium: { top: '36.5%', left: '40.9%' },
      Large: { top: '36.5%', left: '40.9%' }
    }
  ],
  Barge: [
    // Berth 1 (index 0)
    {
      Small: { top: '32.9%', left: '66.7%' },
      Medium: { top: '31.3%', left: '66.7%' },
      Large: { top: '24.5%', left: '66.7%' }
    },
    // Berth 2
    {
      Small: { top: '32.9%', left: '58.6%' },
      Medium: { top: '31.3%', left: '58.6%' },
      Large: { top: '24.5%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '32.9%', left: '48.4%' },
      Medium: { top: '31.3%', left: '48.4%' },
      Large: { top: '24.5%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '32.9%', left: '38.3%' },
      Medium: { top: '31.3%', left: '38.3%' },
      Large: { top: '24.5%', left: '38.3%' }
    },
    // Berth 5
    {
      Small: { top: '32.9%', left: '30.3%' },
      Medium: { top: '31.3%', left: '30.3%' },
      Large: { top: '24.5%', left: '30.3%' }
    },
    {
      Small: { top: '39.5%', left: '39.4%' },
      Medium: { top: '39.5%', left: '39.4%' },
      Large: { top: '39.5%', left: '39.4%' }
    }
  ],
  Tanker: [
    // Berth 1 (index 0)
    {
      Small: { top: '34.5%', left: '67.5%' },
      Medium: { top: '32.7%', left: '67.1%' },
      Large: { top: '27.6%', left: '66.7%' }
    },
    // Berth 2
    {
      Small: { top: '34.5%', left: '59.4%' },
      Medium: { top: '32.7%', left: '59%' },
      Large: { top: '27.6%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '34.5%', left: '49.3%' },
      Medium: { top: '32.7%', left: '48.9%' },
      Large: { top: '27.6%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '34.5%', left: '39%' },
      Medium: { top: '32.7%', left: '38.7%' },
      Large: { top: '27.6%', left: '38.3%' }
    },
    // Berth 5
    {
      Small: { top: '34.5%', left: '31%' },
      Medium: { top: '32.7%', left: '30.7%' },
      Large: { top: '27.6%', left: '30.3%' }
    },
    {
      Small: { top: '40.7%', left: '39.3%' },
      Medium: { top: '40.7%', left: '39.3%' },
      Large: { top: '40.7%', left: '39.3%' }
    }
  ],
  BulkBarge: [
    // Berth 1 (index 0)
    {
      Small: { top: '29.0%', left: '66.95%' },
      Medium: { top: '26.8%', left: '66.6%' },
      Large: { top: '24.5%', left: '66.6%' }
    },
    // Berth 2
    {
      Small: { top: '29.0%', left: '58.9%' },
      Medium: { top: '26.8%', left: '58.5%' },
      Large: { top: '24.5%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '29.0%', left: '48.75%' },
      Medium: { top: '26.8%', left: '48.4%' },
      Large: { top: '24.5%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '29.0%', left: '38.55%' },
      Medium: { top: '26.8%', left: '38.2%' },
      Large: { top: '24.5%', left: '38.2%' }
    },
    // Berth 5
    {
      Small: { top: '29.0%', left: '30.55%' },
      Medium: { top: '26.8%', left: '30.1%' },
      Large: { top: '24.5%', left: '30.2%' }
    },
    {
      Small: { top: '39.3%', left: '39.3%' },
      Medium: { top: '39.3%', left: '39.3%' },
      Large: { top: '39.3%', left: '39.3%' }
    }
  ],
  GeneralCargo: [
    // Berth 1 (index 0)
    {
      Small: { top: '33.2%', left: '67.5%' },
      Medium: { top: '28%', left: '67.1%' },
      Large: { top: '24%', left: '66.7%' }
    },
    // Berth 2
    {
      Small: { top: '33.2%', left: '59.4%' },
      Medium: { top: '28%', left: '59%' },
      Large: { top: '24%', left: '58.6%' }
    },
    // Berth 3
    {
      Small: { top: '33.2%', left: '49.3%' },
      Medium: { top: '28%', left: '48.9%' },
      Large: { top: '24%', left: '48.4%' }
    },
    // Berth 4
    {
      Small: { top: '33.2%', left: '39.1%' },
      Medium: { top: '28%', left: '38.7%' },
      Large: { top: '24%', left: '38.3%' }
    },
    // Berth 5
    {
      Small: { top: '33.2%', left: '31%' },
      Medium: { top: '28%', left: '30.7%' },
      Large: { top: '24%', left: '30.3%' }
    },
    {
      Small: { top: '40.7%', left: '39.1%' },
      Medium: { top: '40.7%', left: '39.1%' },
      Large: { top: '40.7%', left: '39.1%' }
    }
  ]
}

export const _TOJInfoPosition = {
  BulkBarge: {
    Small: { height: '90%' },
    Medium: { height: '100%' },
    Large: { height: '100%' }
  },
  Barge: {
    Small: { height: '100%' },
    Medium: { height: '100%' },
    Large: { height: '100%' }
  },
  Tanker: {
    Small: { height: '80%' },
    Medium: { height: '90%' },
    Large: { height: '100%' }
  },
  GeneralCargo: {
    Small: { height: '80%' },
    Medium: { height: '90%' },
    Large: { height: '100%' }
  },
  TSV: {
    Small: { height: '80%' },
    Medium: { height: '90%' },
    Large: { height: '100%' }
  },
  LCT: {
    Small: { height: '80%' },
    Medium: { height: '90%' },
    Large: { height: '100%' }
  }
}

export const _TOJInfoRightPosition = {
  BulkBarge: {
    Small: '2rem',
    Medium: '0.7rem',
    Large: '-0.9rem'
  },
  Barge: {
    Small: '2rem',
    Medium: '1.3rem',
    Large: '-2rem'
  },
  Tanker: {
    Small: '3.8rem',
    Medium: '3.6rem',
    Large: '2.5rem'
  },
  GeneralCargo: {
    Small: '2rem',
    Medium: '1.3rem',
    Large: '-2rem'
  },
  TSV: {
    Small: '3rem',
    Medium: '1.8rem',
    Large: '0.65rem'
  },
  LCT: {
    Small: '2.5rem',
    Medium: '2rem',
    Large: '0.1rem'
  }
}

// this func will impact to image height due to image rotation
export const _getVesselWidthBySize = (name) => {
  // /*
  if (name) {
    let array = name.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '')

    if (names === 'BulkBarge') {
      if (sizes === 'Small') {
        return '80%'
      } else if (sizes === 'Medium') {
        return '90%'
      }
    } else if (names === 'Rig') {
      return '345px'
    }
    return 'auto'
  }
  return 'auto'
}

export const _getVesselHeightBySize = (name) => {
  if (name) {
    let array = name.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '')

    if (names === 'LCT') {
      if (sizes === 'Small') {
        return '80%'
      } else if (sizes === 'Medium') {
        return '90%'
      } else if (sizes === 'Large') {
        return '100%'
      }
    } else if (names === 'TSV') {
      if (sizes === 'Small') {
        return '80%'
      } else if (sizes === 'Medium') {
        return '90%'
      } else if (sizes === 'Large') {
        return '100%'
      }
    } else if (names === 'Tanker') {
      if (sizes === 'Small') {
        return '80%'
      } else if (sizes === 'Medium') {
        return '90%'
      } else if (sizes === 'Large') {
        return '100%'
      }
    } else if (names === 'GeneralCargo') {
      if (sizes === 'Small') {
        return '80%'
      } else if (sizes === 'Medium') {
        return '90%'
      } else if (sizes === 'Large') {
        return '100%'
      }
    } else if (names === 'BulkBarge' && sizes === 'Small') {
      return '90%'
    } else if (names === 'Rig') {
      return '282px'
    } else {
      return '100%'
    }
  }
  return '100%'
}

export const _getVesselName = (name) => {
  if (name) {
    let array = name.split('|')
    let names = array[0].replace(/[/_ ]/g, '')

    return names
  }
}

export const _getVesselImage = (name) => {
  if (name) {
    let array = name.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '')
    if (
      names === 'BulkBarge' ||
      names === 'Barge' ||
      names === 'Tanker' ||
      names === 'GeneralCargo' ||
      names === 'TSV' ||
      names === 'Rig' ||
      names === 'LCT'
    ) {
      return names === 'Rig' ? `V${names}` : `V${names}${sizes}`
    }
  }
}

export const _getVesselPositions = (data, berth) => {
  const defaultPosition = { top: 0, left: 0 }

  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'

    return {
      top: _vesselPositions?.[names]?.[berth - 1][sizes]?.top || 0,
      left: _vesselPositions?.[names]?.[berth - 1][sizes]?.left || 0
    }
  }
  return defaultPosition
}

export const _getTOJPositions = (data) => {
  const defaultPosition = { height: 0 }

  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'

    if (
      names === 'BulkBarge' ||
      names === 'Barge' ||
      names === 'Tanker' ||
      names === 'GeneralCargo' ||
      names === 'TSV' ||
      names === 'LCT'
    ) {
      return {
        height: _TOJInfoPosition[names][sizes]?.height || '100%'
      }
    }
    return defaultPosition
  }
  return defaultPosition
}

export const _getTOJRightPositions = (data, isDolphin = false) => {
  const defaultPosition = { right: 0 }

  if (data) {
    let array = data.split('|')
    let names = array[0].replace(/[/_ ]/g, '')
    let sizes = array[1].replace(/[/_ ]/g, '') || 'Large'

    if (
      names === 'BulkBarge' ||
      names === 'Barge' ||
      names === 'Tanker' ||
      names === 'GeneralCargo' ||
      names === 'TSV' ||
      names === 'LCT'
    ) {
      const right = _TOJInfoRightPosition[names][sizes]
      return right
    }
    return defaultPosition
  }
  return defaultPosition
}
